// extracted by mini-css-extract-plugin
export default {"defaultTable":"DynamicTable_defaultTable__ROVKo","table":"DynamicTable_table__o6-nj"};